function io() {
	const targets = document.querySelectorAll('.catch');
	const options = {
		rootMargin: '0% 0% 0%',
		threshold: 0.5
	};

	const observer = new IntersectionObserver(intersect, options);

	targets.forEach(target => {
		observer.observe(target);
	});

	function intersect(entries) {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				let elements = document.querySelectorAll(".js-io");
				elements.forEach(function (element) {
					element.classList.remove("cng");
				});

			} else {
				let elements = document.querySelectorAll(".js-io");
				elements.forEach(function (element) {
					element.classList.add("cng");
				});

			}
		});
	}
}

io();


$(function () {
	$('.detail__tableArea').scroll(function () {
		$(this).next('.detail__tableArrow').addClass('hide');
		if ($(this).scrollLeft() === 0) {
			$(this).next('.detail__tableArrow').removeClass('hide');
		}
	});
});
